module.exports = __webpack_public_path__ + "img/TEXT1.6c44e5fb.png";